// Dynamic content loader
export const loadSportContent = async (sportId: string) => {
  console.log('loadSportContent - Loading content for sport:', sportId);
  try {
    switch (sportId) {
      case 'pickleball':
        const pbContent = await import('./pickleball');
        console.log('Loaded pickleball content:', pbContent);
        return {
          drills: pbContent.pickleballDrills,
          strategies: pbContent.pickleballStrategies,
          equipment: pbContent.pickleballEquipment,
          fundamentals: pbContent.pickleballFundamentals,
          shotDiagnosis: pbContent.pickleballShotDiagnosis,
          assessments: pbContent.pickleballAssessments,
          videoAnalysis: pbContent.pickleballVideoAnalysis
        };
      case 'tennis':
        const tennisContent = await import('./tennis');
        return {
          drills: tennisContent.tennisDrills,
          strategies: tennisContent.tennisStrategies,
          equipment: tennisContent.tennisEquipment,
          fundamentals: tennisContent.tennisFundamentals,
          shotDiagnosis: tennisContent.tennisShotDiagnosis,
          assessments: tennisContent.tennisAssessments,
          videoAnalysis: tennisContent.tennisVideoAnalysis
        };
      case 'golf':
        const golfContent = await import('./golf');
        console.log('Loaded golf content:', golfContent);
        return {
          drills: golfContent.golfDrills,
          strategies: golfContent.golfStrategies,
          equipment: golfContent.golfEquipment,
          fundamentals: golfContent.golfFundamentals,
          shotDiagnosis: golfContent.golfShotDiagnosis,
          assessments: golfContent.golfAssessments,
          videoAnalysis: golfContent.golfVideoAnalysis
        };
      case 'hiking':
        const hikingContent = await import('./hiking');
        console.log('Loaded hiking content:', hikingContent);
        return {
          drills: hikingContent.hikingDrills,
          strategies: hikingContent.hikingStrategies,
          equipment: hikingContent.hikingEquipment,
          fundamentals: hikingContent.hikingFundamentals,
          shotDiagnosis: hikingContent.hikingInjuries || [],
          assessments: hikingContent.hikingAssessments,
          videoAnalysis: hikingContent.hikingVideoAnalysis
        };
      case 'padel':
        const padelContent = await import('./padel');
        console.log('Loaded padel content:', padelContent);
        return {
          drills: padelContent.padelDrills,
          strategies: padelContent.padelStrategies,
          equipment: padelContent.padelEquipment,
          fundamentals: padelContent.padelFundamentals,
          shotDiagnosis: padelContent.padelShotDiagnosis,
          assessments: padelContent.padelAssessments,
          videoAnalysis: padelContent.padelVideoAnalysis
        };
      case 'badminton':
        const badmintonContent = await import('./badminton');
        console.log('Loaded badminton content:', badmintonContent);
        return {
          drills: badmintonContent.badmintonDrills,
          strategies: badmintonContent.badmintonStrategies,
          equipment: badmintonContent.badmintonEquipment,
          fundamentals: badmintonContent.badmintonFundamentals,
          shotDiagnosis: badmintonContent.badmintonShotDiagnosis,
          assessments: badmintonContent.badmintonAssessments,
          videoAnalysis: badmintonContent.badmintonVideoAnalysis
        };
      case 'racquetball':
        const racquetballContent = await import('./racquetball');
        console.log('Loaded racquetball content:', racquetballContent);
        return {
          drills: racquetballContent.racquetballDrills,
          strategies: racquetballContent.racquetballStrategies,
          equipment: racquetballContent.racquetballEquipment,
          fundamentals: racquetballContent.racquetballFundamentals,
          shotDiagnosis: racquetballContent.racquetballShotDiagnosis,
          assessments: racquetballContent.racquetballAssessments,
          videoAnalysis: racquetballContent.racquetballVideoAnalysis
        };
      case 'squash':
        const squashContent = await import('./squash');
        console.log('Loaded squash content:', squashContent);
        return {
          drills: squashContent.squashDrills,
          strategies: squashContent.squashStrategies,
          equipment: squashContent.squashEquipment,
          fundamentals: squashContent.squashFundamentals,
          shotDiagnosis: squashContent.squashShotDiagnosis,
          assessments: squashContent.squashAssessments,
          videoAnalysis: squashContent.squashVideoAnalysis
        };
      case 'running':
        const runningContent = await import('./running');
        return {
          drills: runningContent.runningDrills,
          strategies: runningContent.runningStrategies,
          equipment: runningContent.runningEquipment,
          fundamentals: runningContent.runningFundamentals,
          shotDiagnosis: runningContent.runningInjuries || [],
          assessments: runningContent.runningAssessments,
          videoAnalysis: runningContent.runningVideoAnalysis
        };
      case 'cycling':
        const cyclingContent = await import('./cycling');
        return {
          drills: cyclingContent.cyclingDrills,
          strategies: cyclingContent.cyclingStrategies,
          equipment: cyclingContent.cyclingEquipment,
          fundamentals: cyclingContent.cyclingFundamentals,
          shotDiagnosis: cyclingContent.cyclingInjuries || [],
          assessments: cyclingContent.cyclingAssessments,
          videoAnalysis: cyclingContent.cyclingVideoAnalysis
        };
      case 'swimming':
        const swimmingContent = await import('./swimming');
        return {
          drills: swimmingContent.swimmingDrills,
          strategies: swimmingContent.swimmingStrategies,
          equipment: swimmingContent.swimmingEquipment,
          fundamentals: swimmingContent.swimmingFundamentals,
          shotDiagnosis: swimmingContent.swimmingInjuries || [],
          assessments: swimmingContent.swimmingAssessments,
          videoAnalysis: swimmingContent.swimmingVideoAnalysis
        };
      case 'strength':
        const strengthContent = await import('./strength');
        return {
          drills: strengthContent.strengthDrills,
          strategies: strengthContent.strengthStrategies,
          equipment: strengthContent.strengthEquipment,
          fundamentals: strengthContent.strengthFundamentals,
          shotDiagnosis: strengthContent.strengthInjuries || [],
          assessments: strengthContent.strengthAssessments,
          videoAnalysis: strengthContent.strengthVideoAnalysis
        };
      default:
        const defaultContent = await import('./pickleball');
        return {
          drills: defaultContent.pickleballDrills,
          strategies: defaultContent.pickleballStrategies,
          equipment: defaultContent.pickleballEquipment,
          fundamentals: defaultContent.pickleballFundamentals,
          shotDiagnosis: defaultContent.pickleballShotDiagnosis,
          assessments: defaultContent.pickleballAssessments,
          videoAnalysis: defaultContent.pickleballVideoAnalysis
        };
    }
  } catch (error) {
    console.error('Error loading sport content for sport:', sportId, error);
    console.error('Error details:', error);
    console.log('Falling back to pickleball content...');
    const fallbackContent = await import('./pickleball');
    return {
      drills: fallbackContent.pickleballDrills,
      strategies: fallbackContent.pickleballStrategies,
      equipment: fallbackContent.pickleballEquipment,
      fundamentals: fallbackContent.pickleballFundamentals,
      shotDiagnosis: fallbackContent.pickleballShotDiagnosis,
      assessments: fallbackContent.pickleballAssessments,
      videoAnalysis: fallbackContent.pickleballVideoAnalysis
    };
  }
};

// Type definitions for sport content
export interface SportDrill {
  id: string;
  title: string;
  description: string;
  difficulty: 'beginner' | 'intermediate' | 'advanced';
  duration: number;
  equipment: string[];
  instructions: string[];
  tips: string[];
}

export interface SportStrategy {
  id: string;
  title: string;
  description: string;
  tips: string[];
}

export interface SportEquipment {
  id: string;
  name: string;
  description: string;
  recommendations: string[];
}

export interface SportShot {
  name: string;
  description: string;
  commonIssues: string[];
  improvements: string[];
  videoUrl: string;
}

export interface SportShotDiagnosis {
  id: string;
  title: string;
  description: string;
  shots: SportShot[];
}

export interface SportFundamental {
  id: string;
  title: string;
  description: string;
  content: string[];
  category: string;
}

export interface SportAssessment {
  id: string;
  title: string;
  description: string;
  category: string;
  questions: SportQuestion[];
}

export interface SportQuestion {
  id: string;
  question: string;
  type: string;
  options: string[];
  correctAnswer: number;
  explanation: string;
}

export interface SportVideoAnalysis {
  title: string;
  description: string;
  features: string[];
  analysisTypes: VideoAnalysisType[];
  personalizedRecommendations: {
    beginner: string[];
    intermediate: string[];
    advanced: string[];
  };
  progressTracking: {
    metrics: string[];
    improvements: string[];
  };
}

export interface VideoAnalysisType {
  id: string;
  name: string;
  description: string;
  keyPoints: string[];
  commonIssues: VideoAnalysisIssue[];
}

export interface VideoAnalysisIssue {
  issue: string;
  symptoms: string[];
  recommendations: string[];
}

export interface SportContent {
  drills: SportDrill[];
  strategies: SportStrategy[];
  equipment: SportEquipment[];
  fundamentals: SportFundamental[];
  shotDiagnosis: SportShotDiagnosis[];
  assessments: SportAssessment[];
  videoAnalysis: SportVideoAnalysis;
}
